<kr-stepper
  class="kr-exchange__stepper"
  data-testid="exchange_crypto_fiat_stepper"
  [steps]="steps"
  [activeStep]="getStep(page())" />

@switch (page()) {
  @case (exchange.SetAmount) {
    <kr-exchange-set-crypto-fiat-amount
      [wallet]="wallet()"
      [wallets]="wallets()"
      [form]="form" />
    <div class="kr-actions">
      <div>
        <button
          type="button"
          fuButton
          size="m"
          uiType="primary"
          data-testid="exchange_crypto_fiat_close_btn"
          (click)="dialogRef.close()"
          class="kr-button-back"
          translate="exchange.dialog.back"></button>
      </div>
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_fiat_set_iban"
        (click)="setStep(exchange.SetIban)"
        translate="exchange.dialog.nextStep"></button>
    </div>
  }
  @case (exchange.SetIban) {
    <kr-exchange-set-crypto-fiat-iban [form]="form" />
    <div class="kr-actions">
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_fiat_set_amount"
        (click)="page.set(exchange.SetAmount)"
        translate="exchange.dialog.back"></button>
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_fiat_go_details"
        (click)="setStep(exchange.Details)"
        translate="exchange.dialog.nextStep"></button>
    </div>
  }
  @case (exchange.Details) {
    <kr-crypto-fiat-details
      [form]="form"
      [wallets]="wallets()"
      (timeLeftChange)="timeLeft.set($event)" />

    <!--    @if (estimation()?.totalValueToSend.amount < 0) {-->
    <!--      <div class="kr-exchange__hint">-->
    <!--        <fu-icon iconName="information" size="16" />-->
    <!--        {{-->
    <!--          'exchange.dialog.minimumExchangeAmount'-->
    <!--            | translate: { limit: 100 }-->
    <!--        }}-->
    <!--      </div>-->
    <!--    }-->

    <div class="kr-actions">
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_fiat_iban"
        (click)="page.set(exchange.SetIban)"
        translate="exchange.dialog.back"></button>
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_fiat_execute"
        [disabled]="timeLeft() === 0"
        (click)="execute()"
        translate="exchange.dialog.execute"></button>
    </div>
  }
  @case (exchange.Success) {
    <kr-exchange-success />
  }
  @case (exchange.Failed) {
    <kr-exchange-failed />
  }
}
